const investorPoints = [
  "Universal emotional foundation across regions and generations",
  "Built-in audience demand from existing fandom",
  "Recurring content opportunities — new seasons, new moments, new rivalries",
  "Path to team, league, venue, and franchise partnerships",
];

export function WhySports() {
  return (
    <section id="why-sports" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 led-grid opacity-25" />
      <div className="absolute inset-0 bg-gradient-to-b from-background via-transparent to-background" />

      <div className="relative mx-auto max-w-7xl px-6">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">Why Sports</p>
          <h2 className="font-display text-4xl sm:text-6xl leading-tight">
            Sports create the memories <span className="text-gradient-ember">people never forget.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7 space-y-6 text-lg text-muted-foreground leading-relaxed">
            <p>
              Sports are one of the most emotional forms of entertainment in the world. Fans
              remember the winning kick, the final shot, the walk-off hit, the championship
              save, and the rivalry game that came down to one play.
            </p>
            <div className="space-y-1 font-display text-2xl sm:text-3xl text-foreground leading-snug">
              <p>They remember where they were.</p>
              <p>Who they were with.</p>
              <p className="text-gradient-ember">How it felt.</p>
            </div>
            <p>
              But for most fans, those moments have always been experienced from the sidelines,
              the stands, the couch, or a screen.
            </p>
            <p className="text-foreground">
              ClutchCube changes the relationship between fans and sports by transforming
              iconic moments from something people <span className="line-through decoration-primary/60">watch</span> into something they{" "}
              <span className="text-gradient-ember font-semibold">physically experience.</span>
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="border border-primary/30 bg-primary/5 rounded-sm p-8 h-full">
              <p className="text-xs uppercase tracking-[0.3em] text-primary mb-6">Why Sports Works for Investors</p>
              <ul className="space-y-4">
                {investorPoints.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-foreground/90 leading-relaxed">
                    <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary shrink-0" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-8 pt-6 border-t border-primary/20 text-sm text-muted-foreground leading-relaxed">
                Sports gives ClutchCube an emotional engine, an addressable audience, and a
                pipeline of recurring content and partnerships that compound with every new
                location.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
